<script>import {
  WeekNumberSystem,
  getMonthIndices,
  getMonthLabels,
  getFirstMonth,
  getWeekOther,
  getWeekStartOther,
  isSameDate,
  getFirstWeekStart
} from "../../../util/date-time-util.js";
import Picker from "./Picker.svelte";
import { createEventDispatcher } from "svelte";
const _browser = typeof window !== "undefined";
export let name = void 0;
export let system = WeekNumberSystem.ISO8601;
export let value = getWeekOther(system, /* @__PURE__ */ new Date());
export let makeSquare = true;
const dispatch = createEventDispatcher();
const getLocale = (locale) => {
  return locale && locale !== "undefined" ? locale : _browser ? navigator.language : "en-US";
};
let cellContentPadding = "0em";
let cellPadding = "0.3em";
let columns = 7;
const firstMonth = getFirstMonth(system);
const monthIndices = getMonthIndices(firstMonth);
$:
  weekStr = value.week.toString().padStart(2, "0");
let open = false;
const getWeekCell = (weekNumber, cellIndex, columns2) => {
  return {
    type: weekNumber.year === value.year ? "primary" : "secondary",
    marked: false,
    selected: weekNumber.year === value.year && weekNumber.week === value.week,
    inside: false,
    value: weekNumber,
    label: weekNumber.week.toString().padStart(2, "0"),
    valueTop: cellIndex < columns2,
    valueLeft: cellIndex % columns2 === 0
  };
};
let cells = [];
$: {
  const date = getFirstWeekStart(system, value.year).date;
  date.setDate(date.getDate() - 14);
  cells = new Array(56);
  for (let i = 0; i < 56; i++) {
    cells[i] = getWeekCell(getWeekOther(system, date), i, columns);
    date.setDate(date.getDate() + 7);
  }
}
const cellClicked = (ev) => {
  const index = ev.detail.index;
  const cell = ev.detail.cell;
  if (cell && !cell.disabled && (cell.type === "primary" || cell.type === "secondary")) {
    cells = cells.map((c, i) => {
      c.selected = i === index;
      return c;
    });
    value = cells[index].value;
    dispatch("changed", { name, value });
    open = false;
  }
  dispatch("action");
};
const moveTo = (delta) => {
  console.log("month-picker moveTo with cur value = ", value);
  if (value !== void 0) {
    const date = getWeekStartOther(system, value);
    date.setDate(date.getDate() + delta);
    value = getWeekOther(system, date);
    dispatch("changed", { name, value });
  }
  open = false;
  dispatch("action");
};
const showCells = () => {
  if (cells !== void 0 && cells.length > 0) {
    open = true;
  }
  dispatch("action");
};
</script>

<div
	class="picker week-picker"
	on:blur={() => {
		open = false;
	}}
	tabindex="-1"
>
	<span>
		<span
			class="button icon-chevron-left"
			on:keypress={(ev) => moveTo(-7)}
			on:click={(ev) => moveTo(-7)}
			role="button"
			tabindex="0"
		/><span class="open" role="button" tabindex="0" on:keypress={showCells} on:click={showCells}
			>{weekStr}</span
		><span
			class="button icon-chevron-right"
			on:keypress={(ev) => moveTo(+7)}
			on:click={(ev) => moveTo(+7)}
			role="button"
			tabindex="0"
		/>
	</span>
	<div class={open ? 'open' : ''}>
		<Picker
			{cells}
			cellCharWidth={3}
			itemCharWidth={2}
			{cellContentPadding}
			{cellPadding}
			{columns}
			{makeSquare}
			on:cell-click={cellClicked}
		/>
	</div>
</div>

<style>
	div.picker {
		--base-color-onSurface-primary: #dbe4e7;
		--base-color-primary-default: #6bae85;
		--font-family: Roboto;
		--font-size: 1.125rem;
		--font-weight: 700;
		--letter-spacing: 0.0625rem;
	}

	div.picker {
		--picker-font: normal var(--font-weight) var(--font-size) / 1.2 var(--font-family);
		--picker-font-spacing: var(--letter-spacing);
		--picker-text-color: var(--base-color-onSurface-primary);
		--picker-button-color: var(--base-color-primary-default);
	}

	div.picker.week-picker {
		display: inline-block;
		vertical-align: bottom;
	}

	.picker > span {
		background-color: transparent;
		color: var(--picker-text-color);
		font: var(--picker-font);
		letter-spacing: var(--picker-font-spacing);
		line-height: 1.22222;
	}

	.picker > div {
		position: absolute;
		display: none;
		left: 0;
	}
	.picker > div.open {
		display: block;
		z-index: 10000;
	}

	div.picker.week-picker > span {
		display: inline-flex;
		align-items: center;
		align-content: stretch;
		gap: 0.65em;
	}

	div.picker.week-picker > span > span.open {
		flex: 1 0 auto;
		cursor: pointer;
	}
	div.picker.week-picker > span > span.button {
		flex: 0 0 auto;
		cursor: pointer;
	}
</style>
